import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { Results } from '@atlassian/cssxp-typescommon';
import { CreditSearchParams, Credit } from '@atlassian/cssxp-types-billing';

const client = createAxiosClient({ baseURL: '/api/1/credits' }, ServiceProxyMap.ANS);

export async function searchCreditsForCloudSite(cloudSiteId: string) {
  const result = await client.get(`/${cloudSiteId}`);
  return result.data;
}

export async function searchCredits(params: CreditSearchParams): Promise<Results<Credit>> {
  const result = await client.get('/', { params });
  return result.data;
}
